import React from "react";
import MoneyPng from "../../../assets/MoneyPng.png";
import { IoCalendarClearOutline } from "react-icons/io5";
import { MdInfo } from "react-icons/md";
import useWindowDimensions from "../../../helpers/Hooks/useWindowDimensions";
import UserTable from "./UserTable";

const Income = ({ today }) => {
  const { height, width } = useWindowDimensions();
  const incomeDepositHistory = [
    {
      date: "2022-10-03",
      amount: "$2,164.93",
    },
    {
      date: "2022-09-01",
      amount: "$2,169.19",
    },
    {
      date: "2022-08-01",
      amount: "$2,169.18",
    },
    {
      date: "2022-07-01",
      amount: "$2,169.19",
    },
    {
      date: "2022-06-01",
      amount: "$2,169.19",
    },
    {
      date: "2022-05-02",
      amount: "$2,169.19",
    },
    {
      date: "2022-04-01",
      amount: "$2,169.19",
    },
    {
      date: "2022-03-01",
      amount: "$2,075.61",
    },
    {
      date: "2022-02-01",
      amount: "$2,075.60",
    },
    {
      date: "2022-01-03",
      amount: "$2,075.60",
    },
    {
      date: "2021-12-01",
      amount: "$2,056.67",
    },
    {
      date: "2021-11-01",
      amount: "$2,056.66",
    },
  ];

  return (
    <main>
      {/* {JSON.stringify(height)} */}
      {/* <table className="flex border rounded-md">
        <thead className="flex-grow">
          <tr className="flex flex-col text-sm font-semibold text-blackText">
            <td className="tdTag">Name</td>
            <td className="tdTag">Social Security Number</td>
            <td className="tdTag" id="lastRow">
              Date of Birth
            </td>
          </tr>
        </thead>
        <tbody className="flex-grow">
          <tr className="flex flex-col text-sm font-medium text-greySecondary">
            <td className="tdTag">
              <span className="mr-1">:</span>Peter Parker
            </td>
            <td className="tdTag">
              <span className="mr-1">:</span>xxxxxxxxxx2314
            </td>
            <td className="tdTag" id="lastRow">
              <span className="mr-1">:</span>02-02-2002
            </td>
          </tr>
        </tbody>
      </table> */}
      {/* Table 1 */}
      {/* <main className="mt-2 flex flex-col text-xs font-semibold">
        <section className="flex flex-grow items-center border rounded-t-md">
          <div className="tdTag_table3 text-blackText">Name :</div>
          <div className="tdTag_table3 font-medium text-greySecondary">
            Peter Parker
          </div>
        </section>
        <section className="flex flex-grow items-center border">
          <div className="tdTag_table3 text-blackText">SSN :</div>
          <div className="tdTag_table3 font-medium text-greySecondary">
            ### ### 2314
          </div>
        </section>
        <section className="flex flex-grow items-center border">
          <div className="tdTag_table3 text-blackText">Report date :</div>
          <div className="tdTag_table3 font-medium text-greySecondary">
            2023-01-15
          </div>
        </section>
      </main> */}
      {/* Name table*/}
      {/* <div className="flex flex-col">
        <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8 "> */}
      {/* Akbarsha's table -------- code */}
      {/* <div className="my-2 overflow-hidden border border-border rounded-[6px]">
        <table className="min-w-full">
          <tbody className="text-left">
            <tr className="border-b-[0.5px] border-border">
              <th
                scope="col"
                className="px-4 py-[11px] first-letter:w-[50%] text-xs font-semibold text-blackText"
              >
                Name :
              </th>
              <td className="px-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary">
                Peter Parker
              </td>
            </tr>
            <tr className="border-b-[0.5px] border-border">
              <th
                scope="col"
                className="w-[50%] text-xs font-semibold text-blackText py-[11px] px-4"
              >
                SSN :
              </th>
              <td className="px-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                ### ### 2314
              </td>
            </tr>
            <tr className="">
              <th
                scope="col"
                className="w-[50%] text-xs font-semibold text-blackText py-[11px] px-4"
              >
                Report date :
              </th>
              <td className="px-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                {today}
              </td>
            </tr>
          </tbody>
        </table>
      </div> */}
      <UserTable />

      <main
        className={`px-1 overflow-y-scroll`}
        style={{ height: `${height - 303}px` }}
      >
        {/* {JSON.stringify(width)} */}
        {/* Money img */}
        <section className="mt-6 py-0 px-0 flex items-center rounded-md">
          <div className="flex items-center">
            <section className="mb-1 text-[50px] font-bold text-primary">
              $4,584
            </section>
            <section className={`${width > 390 ? `ml-5` : `ml-2`}`}>
              {" "}
              <div className="w-full text-base font-semibold whitespace-pre">
                Monthly income
              </div>
              <div className="w-full text-xs font-medium text-greySecondary">
                based on semi-monthly normalized income over the last three
                months
              </div>
            </section>
          </div>
        </section>

        <div className="mt-6 overflow-hidden">
          <table className="min-w-full">
            {/* table head */}
            <thead className="text-center text-xs font-semibold">
              <tr className="flex items-center justify-center text-center">
                <div scope="col" className="w-[50%] py-[11px]"></div>
                <div
                  scope="col"
                  className="w-[25%] tdTag_table3 px-0 flex items-center justify-center text-blackText border-x border-t rounded-tl"
                >
                  110 days
                </div>
                <div
                  scope="col"
                  className="w-[25%] tdTag_table3 px-0 flex items-center justify-center text-blackText border-r border-t rounded-tr-md"
                >
                  365 days
                </div>
              </tr>
            </thead>

            <tbody className="text-xs font-medium">
              {/* 1st row */}
              <tr className="flex justify-center items-center">
                <div
                  scope="col"
                  className="w-[50%] tdTag_table3 flex items-center justify-start text-blackText border-l border-t border-b rounded-l-md"
                >
                  Semi-monthly{width > 485 ? null : <br />} normalized income
                </div>
                <div
                  scope="col"
                  className={`w-[25%] tdTag_table3 px-0 ${
                    width > 485 ? `` : `py-4`
                  } flex items-center justify-center flex-grow text-greySecondary border `}
                >
                  $2,291.84
                </div>
                <div
                  scope="col"
                  className={`w-[25%] tdTag_table3 px-0 ${
                    width > 485 ? `` : `py-4`
                  } flex items-center justify-center flex-grow text-greySecondary border border-l-0 rounded-br-md`}
                >
                  $2,249.79
                </div>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-6 overflow-hidden">
          <table className="min-w-full">
            {/* table head */}
            <thead className="text-xs font-medium">
              <tr className="flex items-center justify-start">
                <div
                  scope="col"
                  className="tdTag_table3 text-blackText border-x border-t rounded-tl"
                >
                  Primary income{width > 485 ? null : <br />} source
                </div>
                <div
                  scope="col"
                  className={`tdTag_table3 ${
                    width > 485 ? `` : `py-4`
                  } px-0 flex items-center justify-center text-blackText border-r border-t rounded-tr-md`}
                >
                  Daily Bugle
                  {/* {width > 485 ? null : <br />} Inc. */}
                </div>
              </tr>
            </thead>

            <tbody className="text-xs font-medium">
              {/* 1st row */}
              <tr className="flex justify-center items-center">
                <div
                  scope="col"
                  className="tdTag_table3 flex items-center justify-start flex-grow border"
                >
                  Income period (days)
                </div>
                <div
                  scope="col"
                  className="tdTag_table3 px-0 flex items-center justify-center flex-grow text-grey border-y border-r"
                >
                  31
                </div>
              </tr>
              {/* 2nd row */}
              <tr className="flex justify-center items-center">
                <div
                  scope="col"
                  // ${width <= 323 ? `` : ``}
                  className={`tdTag_table3 flex items-center justify-start flex-grow border-x border-b`}
                >
                  Missing last expected{width > 485 ? null : <br />} income
                  deposit
                </div>
                <div
                  scope="col"
                  className={`tdTag_table3 px-0 ${width > 485 ? `` : `py-4`} ${
                    width <= 323 ? `` : ``
                  } flex items-center justify-center flex-grow text-grey  border-r border-b`}
                >
                  No
                </div>
              </tr>
              {/* 3nd row */}
              <tr className="flex justify-center items-center">
                <div
                  scope="col"
                  className="tdTag_table3 flex items-center justify-start flex-grow border-x border-b"
                >
                  Unemployment{width > 485 ? null : <br />} income detected
                </div>
                <div
                  scope="col"
                  className={`tdTag_table3 px-0 ${
                    width > 485 ? `` : `py-4`
                  } flex items-center justify-center flex-grow text-grey  border-r border-b`}
                >
                  No
                </div>
              </tr>
              {/* 3rd row */}
              <tr className="flex justify-center items-center">
                <div
                  scope="col"
                  className="tdTag_table3 flex items-center justify-start flex-grow border-x border-b"
                >
                  Unemployment is{width > 485 ? null : <br />} primary income
                </div>
                <div
                  scope="col"
                  className={`tdTag_table3 px-0 ${
                    width > 485 ? `` : `py-4`
                  } flex items-center justify-center flex-grow text-grey  border-r border-b`}
                >
                  No
                </div>
              </tr>
              {/* 4th row */}
              <tr className="flex justify-center items-center ">
                <div
                  scope="col"
                  className="tdTag_table3 flex items-center justify-start flex-grow border-x border-b rounded-bl-md"
                >
                  Social Security is{width > 485 ? null : <br />} primary income
                </div>
                <div
                  scope="col"
                  className={`tdTag_table3 px-0 ${
                    width > 485 ? `` : `py-4`
                  } flex items-center justify-center flex-grow text-grey border-r border-b rounded-br-md`}
                >
                  No
                </div>
              </tr>
            </tbody>
          </table>
        </div>
        {/* Income History */}
        <main>
          <section className="mt-6 flex items-center justify-between">
            <div className="text-xs font-semibold text-blackText">
              Income deposit history
            </div>
            <div className="text-xs font-medium text-grey">scroll right</div>
          </section>
          <section className="mt-5 mb-[2px] flex overflow-x-scroll">
            {incomeDepositHistory.map((item) => {
              return (
                <section
                  key={item.date}
                  className="relative mb-1 mr-0 last:mr-0 flex flex-col items-center justify-center"
                >
                  <div className="text-sm font-semibold text-primary">
                    {item.amount}
                  </div>
                  <div className="my-3 w-full h-[1px] bg-border"></div>
                  <div className="absolute -mt-[2.5px] w-5 h-5 flex items-center justify-center bg-white border border-border rounded-full shadow-md">
                    <div className="w-[10px] h-[10px] bg-secondary rounded-full"></div>
                  </div>
                  <div className="mb-2 w-24 text-xs font-medium text-blackText flex items-center justify-center">
                    {item.date}
                  </div>
                </section>
              );
            })}
          </section>
        </main>
      </main>

      {/* Warning MsgF */}
      {/* <section className="mt-7 py-4 px-4 flex bg-warningBg border border-warning rounded-md">
        <div className="iconCon">
          <MdInfo className="infoIcon" />
        </div>
        <div className="ml-4 text-xs font-medium">
          This customer report was prepared for a permissible purpose under the
          far Credit Report Act
        </div>
      </section> */}
    </main>
  );
};

export default Income;
